function App({ children }) {
  return <>{children}</>;
}

export default App;
